import { render, staticRenderFns } from "./ZNPMBIAS.vue?vue&type=template&id=a71e1bc4&scoped=true&"
import script from "./ZNPMBIAS.vue?vue&type=script&lang=js&"
export * from "./ZNPMBIAS.vue?vue&type=script&lang=js&"
import style0 from "./ZNPMBIAS.vue?vue&type=style&index=0&id=a71e1bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71e1bc4",
  null
  
)

export default component.exports